import { jsx as t } from "react/jsx-runtime";
import * as s from "react";
import * as o from "@radix-ui/react-popover";
import { cn as m } from "../lib/utils.js";
const c = o.Root, g = o.Trigger, p = s.forwardRef(({ className: e, align: a = "center", sideOffset: r = 4, noAnimation: i = !1, ...n }, d) => /* @__PURE__ */ t(o.Portal, { children: /* @__PURE__ */ t(
  o.Content,
  {
    ref: d,
    align: a,
    sideOffset: r,
    className: m(
      "pointer-events-auto z-[9999] w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none",
      !i && "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]",
      e
    ),
    ...n
  }
) }));
p.displayName = o.Content.displayName;
export {
  c as Popover,
  p as PopoverContent,
  g as PopoverTrigger
};
